import React, {Component} from 'react';
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import getFieldFactory from '../../Endpoint/FieldFactory';
import FieldGroups from '../FieldGroups';

class RequestParameters extends Component {

	render() {

		const newCustomField = {
			name:   'request-body',
			label:  'Request Body',
			fields: [
        {
          id:        'value',
          inputType: 'textarea',
          value:     '',
          label:     'Request Body',
          dynamic:   false,
        },
			],
		};

		const {addSubField, group} = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					<React.Fragment>
						<h3>Request Body</h3>
            <p>Here you can compose the body of the request.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<button onClick={() => addSubField(endpointId, [ newCustomField ], currentItem, group, action)} className="button-secondary">
							Add request body
						</button>

						<FieldGroups group={group}/>

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(RequestParameters);
